<template>
	<div class="brick">
		<notices />
	</div>
</template>

<script>
import { apiHome, apiTest } from '@/api/index';
import Notices from '@/views/basicinformation/notice/Notices';

export default {
	methods: {
		async home() {
			await apiHome();
		},
		async test() {
			const { data } = await apiTest();
			console.log(data);
		},
	},
	components: {
		Notices,
	},
	created() {
		//this.$store.sideIndex = 0;
		this.$store.commit('setSideIndex', 0);
		this.$store.commit('setSelectedMenu', '');
		this.$store.commit('setSubTitle', '');

		this.home();
	},
};
</script>

<style></style>
